import { gql } from '@anyx/common-graphql';

export const HAS_LOGISTICS_CHANNEL = gql(/* GraphQL */ `
  query HasLogisticsChannel($storeId: Long) {
    hasLogisticsChannel(storeId: $storeId) {
      boolean
    }
  }
`);
